import React from 'react';

function LoadingSpinner({ size = 'medium', text = 'Loading...' }) {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-surface-950">
      <div className={`${sizeClasses[size]} border-4 border-surface-600 border-t-accent rounded-full animate-spin mb-4`}></div>
      <p className="text-gray-400 text-sm">{text}</p>
    </div>
  );
}

export default LoadingSpinner;
